import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select, TreeSelect, Row, Col} from "antd";
import {useModel} from "../../../models"

const {Option} = Select;
const {RangePicker} = DatePicker;
const rangeConfig = {
    rules: [{type: 'array', required: true, message: 'Please select time!'}],
};
const materialSelect = [
    {key: "11301", value: "潍柴动力"},
    {key: "11302", value: "欧润油品"},
    {key: "11303", value: "北京中心库"},
    {key: "11304", value: "辽宁利源丰越"},
]

const proceedType = [
    {type: "未收款"},
    {type: "部分收款"},
    {type: "全部收款"},
]
export default function () {
    const [{searchParam}, {setSearchParam, loadSupplierList}] = useModel("supplierBill")
    const [{supplierTypeDict}, {getSupplierTypeDict, getAccountTypeDict,}] = useModel("cmDict");

    const [form] = Form.useForm();

    useEffect(() => {
        // form.setFieldsValue(searchParam)//不设置
        getSupplierTypeDict()
    }, [])
    const onFinish = () => {
        let data = form.getFieldValue()
        // console.log(params)
        loadSupplierList({data})
    }
    const onChangeVal = (event) => {
        // console.log(event)
        // setSearchParam(event)
    }
    const reset = () => {
        form.resetFields()
        // setSearchParams({})        
        loadSupplierList({data: {}})
    }
    return (
        <Form
            form={form}
            name="material_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={onChangeVal}
            labelCol={{span: 12}}

        >
            <Form.Item
                name="supplierName"
                label="供应商名称"
            >
                <Input placeholder="供应商名称" style={{width:"200px"}}/>
            </Form.Item>
            <Form.Item
                name="supplierType"
                label="供应商类型"
            >
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="供应商类型"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={supplierTypeDict}
                    style={{width:"200px"}}
                />
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            onClick={reset}
                            className="margin-left-8"
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}